<template>
  <section class="quote-info">
    <template  v-if="isEndorsement">
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box">
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <div
          class="table"
          :class="item.class">
          <div
            v-for="(sumItem,sumIndex) in item.list"
            v-show="sumItem.type!='array' || !sumItem.notShow"
            :key="sumIndex"
            class="tr">
            <span>{{ sumItem.name }}</span>
            <span v-if="formData[sumItem.field] == oldForm[sumItem.field]||sumItem.noCompare">
              {{ sumItem.type=='value'?sumItem.value:showCompare(sumItem, formData[sumItem.field]) }}
            </span>
            <span
              v-else
              class="compare">
              <span class="text-line color-danger">
                {{ sumItem.type=='value'?sumItem.oldValue:showCompare(sumItem, oldForm[sumItem.field]) }}
              </span>
              <span class="color-success">
                {{ sumItem.type=='value'?sumItem.value:showCompare(sumItem, formData[sumItem.field]) }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box"
        :class="item.boxClass" >
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <div
          class="table"
          :class="item.class">
          <div
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.notShow"
            :key="sumIndex"
            class="tr">
            <span>{{ sumItem.name }}</span>
            <span
              v-if="sumItem.type == 'value'&&!sumItem.option"
              v-copy="sumItem.value">
              {{ sumItem.value }}
            </span>
            <span
              v-else-if="sumItem.type == 'file'"
              class="blue pointer"
              @click="openFile(sumItem.value.url)">
              {{ getClientName(sumItem.value) }}
              <!--              {{ sumItem.value.client_name }}-->
            </span>
            <span
              v-else-if="sumItem.type == 'array'"
            >
              <span
                v-for="(sum,index) in sumItem.value"
                :key="'sum'+index"
                v-copy="sum.name">{{sum.name}}<br></span>
            </span>
            <span
              v-else
              v-copy="showCompare(sumItem, formData[sumItem.field])">
              <span  v-if="sumItem.type == 'value'">{{ sumItem.value }}</span>
              <span v-else>{{ showCompare(sumItem, formData[sumItem.field]) }}</span>
            </span>
          </div>
        </div>
      </div>
    </template>
    <div
      class="box">
      <h2>Insured Details</h2>
      <div
        v-for="(item,index) in nm_pa_list"
        :key="index"
        class="table">
        <div class="tr th">
          <span>Pet {{index+1}}</span>
        </div>

        <div class="tr">
          <span>Species</span>
          <span
            v-copy="getAllOptionName31('type_of_pet',item.type_of_pet)"
            :class="{'green-tip':compareChange(index,'type_of_pet')}">{{ getAllOptionName31('type_of_pet',item.type_of_pet) }}</span>
        </div>
        <div class="tr">
          <span>Name of the Pet</span>
          <span
            v-if="!compareChange(index,'name')"
            v-copy="item.name"
          >
            {{ item.name}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ oldTravle(index,'name') }}
            </span>

            <span
              class="color-success">
              {{ item.name}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>Breed</span>
          <span
            v-copy="getAllOptionName31(item.type_of_pet==1?'cat_breeds':'dog_breeds',item.breed_id)"
            :class="{'green-tip':compareChange(index,'type_of_pet')}">{{ getAllOptionName31(item.type_of_pet==1?'cat_breeds':'dog_breeds',item.breed_id)}}</span>
        </div>
        <div class="tr">
          <span>Colour/Marking</span>
          <!--          <span :class="{'green-tip':compareChange(index,'fst_nm')}">{{ item.fst_nm }}</span>-->
          <span
            v-if="!compareChange(index,'colour_marking')"
            v-copy="item.colour_marking"
          >
            {{ item.colour_marking}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{oldTravle(index,'colour_marking')}}
            </span>

            <span
              class="color-success">
              {{ item.colour_marking}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>Microchip No.</span>
          <span
            v-if="!compareChange(index,'microchip_no')"
            v-copy="item.microchip_no"
          >
            {{ item.microchip_no}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ oldTravle(index,'microchip_no') }}
            </span>

            <span
              class="color-success">
              {{ item.microchip_no}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>Date of Birth</span>
          <span
            v-if="!compareChange(index,'dob')"
            v-copy="showHKMon(item.dob)"
          >
            {{ showHKMon(item.dob)}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ showHKMon(oldTravle(index,'dob')) }}
            </span>

            <span
              class="color-success">
              {{ showHKMon(item.dob)}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>Gender</span>
          <span
            v-if="!compareChange(index,'sex')"
            v-copy="getAllOptionName31('sex_of_pet',item.sex)"
          >
            {{ getAllOptionName31('sex_of_pet',item.sex)}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{getAllOptionName31('sex_of_pet',oldTravle(index,'sex'))  }}
            </span>

            <span
              class="color-success">
              {{getAllOptionName31('sex_of_pet',item.sex)}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>Neuter</span>
          <span
            v-if="!compareChange(index,'is_neuter')"
          >
            {{ getOptionName('yesNoOptions',item.is_neuter)}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ getOptionName('yesNoOptions',oldTravle(index,'is_neuter')) }}
            </span>

            <span
              class="color-success">
              {{  getOptionName('yesNoOptions',item.is_neuter)}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>Date of Last Mixed Vaccination</span>
          <span
            v-if="!compareChange(index,'last_vaccination_date')"
            v-copy="showHKMon(item.last_vaccination_date)"
          >
            {{ showHKMon(item.last_vaccination_date)}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ showHKMon(oldTravle(index,'last_vaccination_date')) }}
            </span>

            <span
              class="color-success">
              {{ showHKMon(item.last_vaccination_date)}}
            </span >
          </span>
        </div>
        <div class="tr">
          <span>Is Physical Address of the Pet different from Corresponding Address in Hong Kong?</span>
          <span
            v-if="!compareChange(index,'is_diff_pet_addr')"
          >
            {{  getOptionName('yesNoOptions',item.is_diff_pet_addr)}}
          </span>
          <span
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ getOptionName('yesNoOptions',oldTravle(index,'is_diff_pet_addr')) }}
            </span>

            <span
              class="color-success">
              {{  getOptionName('yesNoOptions',item.is_diff_pet_addr)}}
            </span >
          </span>
        </div>
        <template v-if="item.is_diff_pet_addr==1">
          <div class="tr th">
            <span>Risk Location</span>
          </div>
          <div class="tr">
            <span>Room</span>
            <span
              v-if="!compareChange(index,'addr_room')"
              v-copy="item.addr_room"
            >
              {{ item.addr_room}}
            </span>
            <span
              v-else
              class="compare">
              <span
                class="text-line color-danger">
                {{ oldTravle(index,'addr_room') }}
              </span>

              <span
                class="color-success">
                {{ item.addr_room}}
              </span >
            </span>
          </div>
          <div class="tr">
            <span>Floor</span>
            <span
              v-if="!compareChange(index,'addr_floor')"
              v-copy="item.addr_floor"
            >
              {{ item.addr_floor}}
            </span>
            <span
              v-else
              class="compare">
              <span
                class="text-line color-danger">
                {{ oldTravle(index,'addr_floor') }}
              </span>

              <span
                class="color-success">
                {{ item.addr_floor}}
              </span >
            </span>
          </div>
          <div class="tr">
            <span>Block</span>
            <span
              v-if="!compareChange(index,'addr_block')"
              v-copy="item.addr_block"
            >
              {{ item.addr_block}}
            </span>
            <span
              v-else
              class="compare">
              <span
                class="text-line color-danger">
                {{ oldTravle(index,'addr_block') }}
              </span>

              <span
                class="color-success">
                {{ item.addr_block}}
              </span >
            </span>
          </div>
          <div class="tr">
            <span>Building / Estate</span>
            <span
              v-if="!compareChange(index,'addr_building')"
              v-copy="item.addr_building"
            >
              {{ item.addr_building}}
            </span>
            <span
              v-else
              class="compare">
              <span
                class="text-line color-danger">
                {{ oldTravle(index,'addr_building') }}
              </span>

              <span
                class="color-success">
                {{ item.addr_building}}
              </span >
            </span>
          </div>
          <div class="tr">
            <span>Street</span>
            <span
              v-if="!compareChange(index,'addr_street')"
              v-copy="item.addr_street"
            >
              {{ item.addr_street}}
            </span>
            <span
              v-else
              class="compare">
              <span
                class="text-line color-danger">
                {{ oldTravle(index,'addr_street') }}
              </span>

              <span
                class="color-success">
                {{ item.addr_street}}
              </span >
            </span>
          </div>
          <div class="tr">
            <span>District</span>
            <span
              v-if="!compareChange(index,'addr_district')"
              v-copy="getAreaName('district',item.addr_district)"
            >
              {{ getAreaName('district',item.addr_district)}}
            </span>
            <span
              v-else
              class="compare">
              <span
                class="text-line color-danger">
                {{ getAreaName('district',oldTravle(index,'addr_street'))}}
              </span>

              <span
                class="color-success">
                {{ getAreaName('district',item.addr_district)}}
              </span >
            </span>
          </div>
          <div class="tr">
            <span>Area</span>
            <span
              v-if="!compareChange(index,'addr_area')"
              v-copy="getAreaName('area',item.addr_area)"
            >
              {{getAreaName('area',item.addr_area)}}
            </span>
            <span
              v-else
              class="compare">
              <span
                class="text-line color-danger">
                {{ getAreaName('area',oldTravle(index,'addr_area'))}}
              </span>

              <span
                class="color-success">
                {{ getAreaName('area',item.addr_area)}}
              </span >
            </span>
          </div>
          <div class="tr">
            <span>Country / Region</span>
            <span
              v-if="!compareChange(index,'addr_street')"
              v-copy="getAreaName('region',item.addr_region)"
            >
              {{ getAreaName('region',item.addr_region)}}
            </span>
            <span
              v-else
              class="compare">
              <span
                class="text-line color-danger">
                {{ getAreaName('region',oldTravle(index,'addr_region'))}}
              </span>

              <span
                class="color-success">
                {{ getAreaName('region',item.addr_region)}}
              </span >
            </span>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import dayjs from 'dayjs'

export default {
  name: 'PetQuoteInfo',
  mixins: [MixinOptions,MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: Boolean,
      default: true
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    showCompany:{
      type: Boolean,
      default: false
    },
    isQuote:{
      type: Boolean,
      default: false
    },
  },
  computed: {
    oldTravle(){
      return (index,name)=>{
        let pre = this.oldForm||{}
        let preList =pre.nm_pa_list||[]
        if(preList.length<=0)return {}
        return preList[index][name]
      }
    },
    compareChange(){
      return (index,name)=>{
        let {type} = this.form||{}
        let list = this.nm_pa_list||[]
        let pre = this.oldForm||{}
        let preList =pre.pet_info||[]
        if(!this.isEndorsement)return  false
        if(preList.length<=0)return false
        if(!list[index][name]&&!preList[index][name])
          return false
        return list[index][name]!=preList[index][name]||false
      }
    },
    nm_pa_list(){
      let {pet_info=[]} = this.formData||{}
      return pet_info||[]
    },
    compareData() {
      let {quote_coverage_list={},class_id} = this.formData||{}
      let list = [
        {
          title: '',
          class: 'mg-b-10',
          list:
            [
              {
                name: 'Expected Effective Date',
                field: 'pcy_cmnt_dt',
                type:'value',
                noCompare:this.isCancel,
                // value:this.formData.is_eff_dt_delay&&this.isQuote?'ASAP':`${this.formData.pcy_cmnt_date} ${this.formData.is_eff_dt_delay&&!this.isQuote?'(ASAP)':''}`
                value:this.isCancel?this.showHKTime(this.oldForm.pcy_cmnt_dt):this.showHKTime(this.formData.pcy_cmnt_dt),
                oldValue:this.showHKTime(this.oldForm.pcy_cmnt_dt)
              },
              {
                name: 'Expected Expiry Date',
                field: 'pcy_expry_dt',
                type:'value',
                value:this.showHKTime(this.formData.pcy_expry_dt)
                // option:10
              },
              // {
              //   name: 'Optional Benefits',
              //   field: 'benefits',
              //   type:'array',
              //   value:arr
              // },
              {
                name: 'Insurer',
                field: 'company_language',
                notShow:!this.showCompany
              },
            ]
        },
        {
          title: 'Policyholder Detail',
          isCompare: false,
          isBold: true,
          list: [
            {
              name: 'Title',
              field: 'isrd_title',
              fieldCode: 'titleOptions',
              option: 1
            }, {
              name: 'Last Name',
              field: 'isrd_lst_nm'
            }, {
              name: 'First Name',
              field: 'isrd_fst_nm'
            }, {
              name: 'Date of Birth',
              field: 'isrd_dob_date',
            }, {
              name: this.formData.id_type==1?'HKID':'Passport',
              field: 'id_no'
            }, {
              name: 'Nationality',
              field: 'id_nationality_seq_language',
              notShow: this.formData.id_type == 1
            },{
              name: 'Mobile Number',
              field: 'mobile_no',

            },
            {
              name: 'Email',
              field: 'email',
            },
          ],
        },
        {
          title: 'Correspondence Address',
          isBold: false,
          list: [
            {
              name: 'Room',
              field: 'addr_room'
            }, {
              name: 'Floor',
              field: 'addr_floor'
            }, {
              name: 'Block',
              field: 'addr_block'
            }, {
              name: 'Building / Estate',
              field: 'addr_building'
            }, {
              name: 'Street',
              field: 'addr_street'
            }, {
              name: 'District',
              field: 'addr_district',
              addressCode: 'district',
              isAddress: true
            }, {
              name: 'Area',
              field: 'addr_area',
              addressCode: 'area',
              isAddress: true
            }, {
              name: 'Country / Region',
              field: 'addr_region',
              isAddress: true,
              addressCode: 'region'
            },
          ]
        },
      ]
      return list
    },
  },
  methods:{
    getClientName(data){
      let {client_name=''} = data||''
      return client_name
    },
    openFile(url) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    showCompare(item, field,sunF) {
      var change = field
      if (item.option) {
        switch (item.option) {
          case 1:
            change = this.getOptionName(item.fieldCode, field)
            break
          case 10:
            let {pcy_cmnt_dt=''} = this.formData||{}
            change=pcy_cmnt_dt?dayjs(pcy_cmnt_dt).add(1,'year').format('YYYY-MM-DD'):''
            break
          case 27:
            change = this.getAllOptionName27(item.fieldCode, field)
            break
        }
      }
      if (item.isAddress) {
        change = this.getAreaName(item.addressCode, field)
      }
      return change
    },
  }
}
</script>
<style lang="scss" scoped>
.quote-info {
  .box {
    margin-bottom: 15px;
  }
  .mg-b-0 {
    margin-bottom: 0!important;
  }

  .title {
    display: block;
    padding: 15px 0;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }

  .table {
    .tr {
      .compare {
        display: flex;
        align-items: center;

        & > span {
          flex: 1;
        }
      }
    }
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
